import PropTypes from 'prop-types';

import {Box, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui';

import BuyNowPayLaterMessaging, {BNPL_PAGE_TYPE} from '@amblique/king-living/app/components/buy-now-pay-later';
import TrustpilotMicro, {useTrustpilotMicroConfig} from '@amblique/king-living/app/components/trustpilot-micro';
import {useBnplMessagingVisible} from '@amblique/king-living/app/hooks/use-bnpl-messaging-config';

const ProductActionSectionMessaging = ({
  amount,
  currency,
  showBnplPaymentBlock = true,
  showInPageAtcOnMobile,
  ...props
}) => {
  const styles = useMultiStyleConfig('ProductDetail', {});
  const trustpilotMicroConfig = useTrustpilotMicroConfig();
  const isBnplMessagingVisible = useBnplMessagingVisible(amount);
  const showTrustpilot = trustpilotMicroConfig.enabled;
  const showPdpBnplPaymentBlock = showBnplPaymentBlock && isBnplMessagingVisible;

  if (!showTrustpilot && !showPdpBnplPaymentBlock) {
    return null;
  }

  return (
    <Box
      {...styles.productActionSectionMessaging}
      display={{base: showInPageAtcOnMobile ? 'block' : 'none', lg: 'block'}}
      {...props}
    >
      {showTrustpilot && <TrustpilotMicro width="100%" />}

      {showPdpBnplPaymentBlock && (
        <Box {...styles.pdpPaymentMethods}>
          <BuyNowPayLaterMessaging
            amount={amount}
            currency={currency}
            pageType={BNPL_PAGE_TYPE.PRODUCT}
          />
        </Box>
      )}
    </Box>
  );
};

ProductActionSectionMessaging.displayName = 'ProductActionSectionMessaging';
ProductActionSectionMessaging.propTypes = {
  amount: PropTypes.number,
  currency: PropTypes.string,
  showBnplPaymentBlock: PropTypes.bool,
  showInPageAtcOnMobile: PropTypes.bool,
};

export default ProductActionSectionMessaging;
